import { Box } from "@mui/material"
import { Dayjs } from "dayjs"
import React, { useState } from "react"
import { useMediaQuery } from "react-responsive"
import { EVENT_STATUS, MENU_TYPE, SUB_MENU_TYPE } from "src/modules/const"
import { CommonLayout } from "../CommonLayout"
import { TopMenuItem } from "../TopMenuItem"
import { EventListPage } from "./EventListPage"
import { EventListStatusPage } from "./EventListStatusPage"
import { EventRegisterPage } from "./EventRegisterPage"
import { EventSearchItem } from "./EventSearchItem"

interface Props {
  subMenuIndex: number
}

export const EventsPage = ({ subMenuIndex }: Props) => {
  const [fromDate, setFromDate] = useState<Dayjs | null>(null)
  const [toDate, setToDate] = useState<Dayjs | null>(null)
  const [areaID, setAreaID] = useState<number[]>([])
  const [categories, setCategories] = useState<number[]>([])

  const subMenu = [
    {
      title: "event_list",
      icon: "event",
      index: SUB_MENU_TYPE.EVENT_LIST,
      page: (
        <EventListPage
          fromDate={fromDate}
          toDate={toDate}
          areaID={areaID}
          categories={categories}
        />
      ),
      search: (
        <EventSearchItem
          fromDate={fromDate}
          toDate={toDate}
          areaID={areaID}
          categories={categories}
          handleFromDate={setFromDate}
          handleToDate={setToDate}
          handleAreaID={setAreaID}
          handleCategories={setCategories}
        />
      ),
      link: "/event/list",
    },
    {
      title: "event_list_receiving",
      icon: "event_list_receiving",
      index: SUB_MENU_TYPE.EVENT_LIST_RECEIVING,
      page: (
        <EventListStatusPage
          fromDate={fromDate}
          toDate={toDate}
          areaID={areaID}
          categories={categories}
          status={EVENT_STATUS.RECEIVING}
        />
      ),
      search: (
        <EventSearchItem
          fromDate={fromDate}
          toDate={toDate}
          areaID={areaID}
          categories={categories}
          handleFromDate={setFromDate}
          handleToDate={setToDate}
          handleAreaID={setAreaID}
          handleCategories={setCategories}
        />
      ),
      link: "/event/list/receiving",
    },
    {
      title: "event_list_started",
      icon: "consult_confirmation",
      index: SUB_MENU_TYPE.EVENT_LIST_STARTED,
      page: (
        <EventListStatusPage
          fromDate={fromDate}
          toDate={toDate}
          areaID={areaID}
          categories={categories}
          status={EVENT_STATUS.STARTED}
        />
      ),
      search: (
        <EventSearchItem
          fromDate={fromDate}
          toDate={toDate}
          areaID={areaID}
          categories={categories}
          handleFromDate={setFromDate}
          handleToDate={setToDate}
          handleAreaID={setAreaID}
          handleCategories={setCategories}
        />
      ),
      link: "/event/list/started",
    },
    {
      title: "draft",
      icon: "draft",
      index: SUB_MENU_TYPE.EVENT_LIST_DRAFT,
      page: (
        <EventListStatusPage
          fromDate={fromDate}
          toDate={toDate}
          areaID={areaID}
          categories={categories}
          status={EVENT_STATUS.DRAFT}
        />
      ),
      search: (
        <EventSearchItem
          fromDate={fromDate}
          toDate={toDate}
          areaID={areaID}
          categories={categories}
          handleFromDate={setFromDate}
          handleToDate={setToDate}
          handleAreaID={setAreaID}
          handleCategories={setCategories}
        />
      ),
      link: "/event/list/draft",
    },
    {
      title: "event_list_archived",
      icon: "archive",
      index: SUB_MENU_TYPE.EVENT_LIST_ARCHIVED,
      page: (
        <EventListStatusPage
          fromDate={fromDate}
          toDate={toDate}
          areaID={areaID}
          categories={categories}
          status={EVENT_STATUS.ARCHIVED}
        />
      ),
      search: (
        <EventSearchItem
          fromDate={fromDate}
          toDate={toDate}
          areaID={areaID}
          categories={categories}
          handleFromDate={setFromDate}
          handleToDate={setToDate}
          handleAreaID={setAreaID}
          handleCategories={setCategories}
        />
      ),
      link: "/event/list/archived",
    },
    {
      title: "event_new",
      icon: "event_new",
      index: SUB_MENU_TYPE.EVENT_CREATE,
      page: <EventRegisterPage />,
      search: null,
      link: "/event/create",
    },
  ]

  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })
  return (
    <>
      {isTablet ? (
        <></>
      ) : (
        <Box position="absolute" sx={{ width: "100%", height: "60px" }}>
          <Box display="flex">
            <TopMenuItem
              mainMenuIndex={MENU_TYPE.EVENT_MANAGE}
              subMenuIndex={subMenuIndex}
              fromDate={fromDate}
              toDate={toDate}
              areaID={areaID}
              categories={categories}
              handleFromDate={setFromDate}
              handleToDate={setToDate}
              handleAreaID={setAreaID}
              handleCategories={setCategories}
            />
          </Box>
        </Box>
      )}

      <CommonLayout subMenu={subMenu} subMenuIndex={subMenuIndex} />
    </>
  )
}
